import { ShoppingCartSummaryDto } from "@/api/models/shoppingCart.model";
import { shoppingCartInitialState } from "./shoppingCart";
import { SHOPPING_CART_CLEAR_STATE } from "./constants";

const clear = (state: any) => {
	Object.assign(state, shoppingCartInitialState());
};

const updateShoppingCartLoading = (state: any, active: boolean) => {
	state.shoppingCartLoading = active;
};

const updateShoppingCartId = (state: any, id: string) => {
	state.shoppingCartId = id;
};

const updateSummary = (state: any, summary: ShoppingCartSummaryDto) => {
	if (summary) {
		const { bundles = [], prices = [], ...summaryData } = summary;
		state.summary = {
			bundles,
			prices,
			...summaryData
		};
	}
};

const activateShoppingCartLoading = (state: any) => {
	updateShoppingCartLoading(state, true);
};

const desactivateShoppingCartLoading = (state: any) => {
	updateShoppingCartLoading(state, false);
};

export default {
	[SHOPPING_CART_CLEAR_STATE]: clear,
	updateShoppingCartLoading,
	updateShoppingCartId,
	updateSummary,
	activateShoppingCartLoading,
	desactivateShoppingCartLoading
};
